import script from "./ProfileAttrs.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfileAttrs.vue?vue&type=script&setup=true&lang=js"

import "./ProfileAttrs.vue?vue&type=style&index=0&id=73132e5a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73132e5a"]])

export default __exports__

/* vue-cli-plugin-import-components */

import ConfirmModal from "@/components/ConfirmModal.vue";
import RecordButton from "@/components/customers/record/RecordButton.vue";
import RecordTableCard from "@/components/customers/record/RecordTableCard.vue";
script.components = Object.assign({}, { ConfirmModal, RecordButton, RecordTableCard }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { ConfirmModal, RecordButton, RecordTableCard }, script.__o.components);}